import { DeserializationUtils } from '../../utils/deserialization-utils';
import { BaseResource } from '../core/base-resource';
import { Group } from './group.model';

export class Tab extends BaseResource {
  name: string;
  keyName: string;
  image: string;
  sortIndex: number;
  mobileImage: string;
  description: string;
  groups: Group[];

  get isRecentlyOrdered(): boolean {
    return this.name === 'RecentlyOrdered';
  }

  deserialize(input: any): this {
    return Object.assign(this, input, {
      groups: DeserializationUtils.deserializeChildren(input, 'groups', Group),
    });
  }
}
